import { render, staticRenderFns } from "./CampaignMgmt.vue?vue&type=template&id=47bb36ca&scoped=true&"
import script from "./CampaignMgmt.vue?vue&type=script&lang=js&"
export * from "./CampaignMgmt.vue?vue&type=script&lang=js&"
import style0 from "./CampaignMgmt.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CampaignMgmt.vue?vue&type=style&index=1&id=47bb36ca&scoped=true&lang=css&"
import style2 from "./CampaignMgmt.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb36ca",
  null
  
)

export default component.exports